module.exports = __webpack_public_path__ + "img/time_invested.6d314fe8.svg";